import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CoreFeature from './CoreFeature';





function Theme() {

   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);



   return (


      <>
         <Helmet>
            <title>Customize Your Theme with Taskflier - The Ultimate Theme Customization Software.</title>
         </Helmet>
            <div class="block-style-thirtySix bg-white lg-container pt-110 pb-80 " id="feature">
               <div class="container">
                  <div class="row">
                     <div class="col-xl-6 col-lg-7  aos-init aos-animate" data-aos="fade-left">

                        <div class="title-style-fourteen">
                           <h6><span class="upper-title custom-name">Theme Customizations</span></h6>
                           <h1>Reflect your brand in just a few clicks</h1>
                        </div>
                        <div class="tag-line">Every organization has its own unique identity and all their public facing digital appearances should reflect that. The Theme Customizations feature empowers you to transform the look and feel of your workspace to align with your brand preferences. Whether you're aiming for visual consistency across teams or just want a more personalized experience, TaskFlier’s intuitive feature make customization effortless enabling you to achieve your desired brand experience in just a few clicks. </div>

                     </div>
                     <div class="col-xl-6 col-lg-5 text-center text-lg-left  aos-init aos-animate" data-aos="fade-right">
                        <div class="d-inline-block md-mt-60">
                           <img src="/main/images/theme-setting.png" alt="" class="w-100" />

                        </div>
                     </div>

                  </div>
               </div>
            </div>

            <div class="fancy-feature-thirtyTwo pt-100 pb-100  ">
               <div class="container">
                  <div class="title-style-two text-center mb-40 md-mb-40">


                     <h3 class="maintitle"><span> What all you can customize</span></h3>
                     {/* <div class="sub-text mt-15 maxsubtitle">
                                       Taskflier's top-rated human resource software integrates perfectly with important applications such as
                                       </div> */}
                  </div>

                  <div class="row  features">


                     <div class="col-lg-4 col-12 ">

                        <div class="Solutions-box aos-init" data-aos="fade-up">

                           <img src="/main/images/Add-logo.png" alt="Task creation" class="w-100"/>
                           <div class="pack-name mt-3">Logo & Branding</div>
                           <hr></hr>
                           <p className="mainp">Seamlessly reflect your brand identity by uploading your company’s logo. TaskFlier’s Theme Customizations feature allows you to align the platform’s visual experience, ensuring a consistent and professional presence across all user interactions.</p>

</div>

                     </div>


                     <div class="col-lg-4 col-12 ">

                        <div class="Solutions-box aos-init" data-aos="fade-up">
                           <img src="/main/images/color-scheme.png" alt="Color Scheme" class="w-100"/>
                           <div class="pack-name mt-3"> Color Scheme</div>
                           <hr></hr>
                           <p className="mainp">Apply your color preferences on key interface elements such as headers, footers, sidebars, buttons, and backgrounds. With our modular design approach, you can fine-tune the visual aspects without disrupting the platform’s core functionality.</p>


                        </div>

                     </div>

                     <div class="col-lg-4 col-12 ">

                        <div class="Solutions-box aos-init" data-aos="fade-up">

                           <img src="/main/images/component-layout.png" alt="Component Layout" class="w-100"/>
                           <div class="pack-name mt-3">Component Layout </div>
                           <hr></hr>
                           <p className="mainp">Arrange your dashboard the way you want. Select whether modules are arranged horizontally or vertically on the dashboard to suit your convenience simply by dragging and dropping them at the desired locations.</p>

                        </div>

                     </div>

                     <div class="col-lg-4 col-12 ">

                        <div class="Solutions-box aos-init" data-aos="fade-up">

                           <img src="/main/images/Display-mode.png" alt="Task creation" class="w-100"/>
                           <div class="pack-name mt-3">Display Mode  </div>
                           <hr></hr>
                           <p className="mainp">Light and dark modes offer flexibility in visual comfort and screen readability. Light mode uses bright backgrounds with dark text, ideal for well-lit environments. Dark mode features darker backgrounds with light text, reducing eye strain in low light. Theme Customizations feature let you switch between the modes whenever desired.</p>

                        </div>

                     </div>
                     <div class="col-lg-4 col-12 ">

                        <div class="Solutions-box aos-init" data-aos="fade-up">
                            <img src="/main/images/menu-labels.png" alt="Task creation" class="w-100"/>
                           <div class="pack-name mt-3">Menu Labels</div>
                           <hr></hr>

                           <p className="mainp">Very often companies use their own specific vocabulary to carry out their internal operations. If the need be, Theme Customizations feature can easily customize the name of the menu items displayed on the platform without changing the underlying functionality in anyway. </p>




                        </div>

                     </div>
                    
                  </div>




               </div>
            </div>


            <div class="fancy-feature-ten pt-80 bg-white" id="feature" hidden>
               <div class="bg-wrapper pt-80">
                  <div class="container">

                     <div class="row align-items-center">

                        <div class="col-lg-5 aos-init aos-animate">
                           <div class="text-wrapper">

                              <h3 class="maintitle">What Group Of Individuals Do Our Theme Customization Services Cater To?</h3>
                              {/* <p className="mainp">
         From recruitment to pension, Taskflier’s human resources management software covers every aspect of the employee lifecycle. Hiring process workflows can be automated and integrated with attendance and payroll management and legal compliance monitoring, all from one software.
       </p> */}


                              <ul className='bullet'>

                                 <li><strong>Small Businesses & Startups</strong>: Achieve an established brand presence in a minimum amount of time.</li>
                                 <li><strong>E-commerce Stores</strong>: Change the designs of product pages and the checkout process.</li>
                               
                              </ul>

                           </div>
                        </div>

                        <div class="col-lg-6 offset-lg-1">
                           <div
                              class="screen-holder-two aos-init aos-animate"
                              data-aos="fade-left"
                              data-aos-duration="1200"
                           >
                              <img src="/main/images/project.jpg" alt="" />
                           </div>
                        </div>

                     </div>


                  </div>
                  <img src="/images/shape/137.svg" alt="" class="shapes shape-one" />
               </div>
            </div>
            <div class="fancy-feature-thirtySeven bg-white lg-container pt-100 " id="stories" hidden>
               <div class="block-style-fortyOne">
                  <div class="container">
                     <div class="row align-items-center">
                        <div class="col-lg-5 aos-init aos-animate" data-aos="fade-right">
                           <div class="title-style-eleven">

                              <h3 class="maintitle">Get Started with Theme Customization Today!
                              </h3>
                           </div>
                           <p class="mainp">
                              Enhance your digital presence with our <strong>professional theme customization</strong> services.
                              Whether you need a minor design tweak or a full-scale theme overhaul,
                              we have the right tools to bring your vision to life.
                           </p>

                           <p class="mainp mt-2">Still have questions? <Link to="/demo-request"><strong>Request a Free Demo</strong></Link> and experience the power of customized themes firsthand!</p>



                        </div>
                        <div class="col-xl-7 col-lg-6 ml-auto text-center text-lg-right aos-init aos-animate" data-aos="fade-left">
                           <div class="img-holder md-mt-50 d-inline-block"><img src="/images/assets/screen_39.png" alt="" /></div>
                        </div>
                     </div>
                  </div>
               </div>


            </div>

            <CoreFeature />
            <div className="faq-classic pt-0 bg-white">
               <div className="container">
                  <div className="row">
                     <div className="col-lg-12">
                        <div className="title-style-one mb-40">
                           <h6 className="font-rubik">Find your answers</h6>
                           <h2>Have any thought? Look here.</h2>
                        </div>
                     </div>
                     <div className="col-lg-12">
                        <div id="accordion" className="md-mt-60">
                           <div className="card">
                              <div className="card-header" id="headingOne">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseOne"
                                       aria-expanded="true"
                                       aria-controls="collapseOne"
                                    >
                                       What is the Theme Customizations feature?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseOne"
                                 className="accordion-collapse collapse show"
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>
                                       The Theme Customizations feature allows users to personalize the visual appearance of the platform. You can adjust elements such as colors, logo, layout, and display mode to match your company’s brand identity or personal preferences. </p>
                                 </div>
                              </div>
                           </div>
                           <div className="card">
                              <div className="card-header" id="headingTwo">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseTwo"
                                       aria-expanded="true"
                                       aria-controls="collapseTwo"
                                    >
                                       Can I apply my company’s branding to the interface?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseTwo"
                                 className="accordion-collapse collapse "
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>Yes. You can fully align the platform with your brand by uploading your logo, setting custom color palettes, and selecting brand-specific color scheme. This ensures a consistent look and feel across all user touchpoints.</p>
                                 </div>
                              </div>
                           </div>
                           <div className="card">
                              <div className="card-header" id="headingThree">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseThree"
                                       aria-expanded="true"
                                       aria-controls="collapseThree"
                                    > Do theme changes affect system performance or functionality?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseThree"
                                 className="accordion-collapse collapse"
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>
                                       Not at all. All theme customizations are optimized to ensure smooth performance. The visual layer is separate from core functionalities, so changes only impact appearance—not operations.
                                    </p>

                                 </div>
                              </div>
                           </div>


                           <div className="card">
                              <div className="card-header" id="headingFour">
                                 <h5 className="mb-0">
                                    <button
                                       className="btn btn-link"
                                       data-bs-toggle="collapse"
                                       data-bs-target="#collapseFour"
                                       aria-expanded="true"
                                       aria-controls="collapseFour"
                                    >
                                       Are themes mobile responsive?
                                    </button>
                                 </h5>
                              </div>
                              <div
                                 id="collapseFour"
                                 className="accordion-collapse collapse "
                                 data-bs-parent="#accordion"
                              >
                                 <div className="card-body">
                                    <p>Yes. All themes are automatically optimized for mobile and tablet devices. Your customized theme will retain its structure and responsiveness across all screen sizes.</p>
                                 </div>
                              </div>
                           </div>

                        </div>
                     </div>
                  </div>
               </div>
            </div>
      </>
   )
}

export default Theme
